"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsProvider = void 0;
var AnalyticsProvider = /** @class */ (function () {
    function AnalyticsProvider(name, isLockedPricing) {
        if (isLockedPricing === void 0) { isLockedPricing = false; }
        this.eventHistory = {};
        this.name = name;
        this.unlockedPricing = !isLockedPricing;
    }
    AnalyticsProvider.prototype.unlockPricing = function () {
        if (!this.unlockedPricing) {
            this.unlockedPricing = true;
        }
    };
    AnalyticsProvider.prototype.handleOnlyOncePerVehicle = function (methodName, vehicle, callback) {
        var _a, _b, _c, _d;
        if (!((_a = this.eventHistory[methodName]) === null || _a === void 0 ? void 0 : _a[(_b = vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin) !== null && _b !== void 0 ? _b : "vinless"])) {
            callback();
            if (typeof this.eventHistory[methodName] === "object") {
                this.eventHistory[methodName][(_c = vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin) !== null && _c !== void 0 ? _c : "vinless"] = 1;
            }
            else {
                this.eventHistory[methodName] = {};
                this.eventHistory[methodName][(_d = vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin) !== null && _d !== void 0 ? _d : "vinless"] = 1;
            }
        }
    };
    AnalyticsProvider.prototype.handleOnlyOncePerSession = function (methodName, callback) {
        if (!this.eventHistory[methodName]) {
            callback();
            this.eventHistory[methodName] = 1;
        }
    };
    /**
     * General Events
     */
    AnalyticsProvider.prototype.opened = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.closed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.dealCreated = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.vehicleAdded = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.vehicleRemoved = function (dealId, vehicle) {
        // no-op
    };
    /**
     * Lead form events
     */
    AnalyticsProvider.prototype.leadFormViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.leadFormStarted = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.leadFormFinished = function (dealId, vehicle) {
        // no-op
    };
    /**
     * Payment Calculator Events
     */
    AnalyticsProvider.prototype.paymentCalcViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.paymentCalcInteraction = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.paymentCalcFinished = function (dealId, vehicle) {
        // no-op
    };
    /**
     * Garage Events
     */
    AnalyticsProvider.prototype.garageViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.garageInteraction = function (dealId, vehicle) {
        // no-op
    };
    /**
     * Test Drive Events
     */
    AnalyticsProvider.prototype.testDriveFormViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.testDriveFormStarted = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.testDriveFormFinished = function (dealId, vehicle) {
        // no-op
    };
    /**
     * Reserve Vehicle Events
     */
    AnalyticsProvider.prototype.reserveVehicleFormViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.reserveVehicleFormStarted = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.reserveVehicleFormFinished = function (dealId, vehicle) {
        // no-op
    };
    /**
     * Upgrade events
     */
    AnalyticsProvider.prototype.upgradesViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.upgradeAdded = function (id, dealId, vehicle, addOnName) {
        // no-op
    };
    AnalyticsProvider.prototype.upgradesFinished = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.menuingViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.ancillaryProductAdded = function (dealId, vehicle, productName) {
        // no-op
    };
    AnalyticsProvider.prototype.menuingFinished = function (dealId, vehicle) {
        // no-op
    };
    /**
     * Trade In Events
     */
    AnalyticsProvider.prototype.tradeInFormViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.tradeInFormStarted = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.tradeInFormFinished = function (dealId, vehicle, programParticipation) {
        // no-op
    };
    /**
     * Soft Credit Pull
     */
    AnalyticsProvider.prototype.softCreditFormViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.softCreditFormStarted = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.softCreditFormFinished = function (dealId, vehicle, applicationId) {
        // no-op
    };
    /**
     * Hard Credit Pull
     */
    AnalyticsProvider.prototype.hardCreditFormViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.hardCreditFormStarted = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.hardCreditFormFinished = function (dealId, vehicle, applicationId) {
        // no-op
    };
    /**
     * Schedule Pickup / Delivery form
     */
    AnalyticsProvider.prototype.schedulePickupOrDeliveryFormViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.schedulePickupOrDeliveryFormStarted = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.schedulePickupOrDeliveryFormFinished = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.pickDeliveryDate = function (date) {
        // no-op
    };
    AnalyticsProvider.prototype.pickDeliveryTime = function (time) {
        // no-op
    };
    AnalyticsProvider.prototype.signInToGarageGarageIcon = function (dealId) {
        // no-op
    };
    AnalyticsProvider.prototype.skipCreditApp = function () {
        // no-op
    };
    AnalyticsProvider.prototype.creditAppPrimaryPageTwo = function () {
        // no-op
    };
    AnalyticsProvider.prototype.cosignerYes = function () {
        // no-op
    };
    AnalyticsProvider.prototype.skipUpgrades = function () {
        // no-op
    };
    AnalyticsProvider.prototype.continueDeal = function (vin, dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.virtualPageView = function (pagePath) {
        // no-op
    };
    AnalyticsProvider.prototype.signInStart = function () {
        // no-op
    };
    AnalyticsProvider.prototype.signInComplete = function (dealId) {
        // no-op
    };
    AnalyticsProvider.prototype.chatDrawerOpened = function (dealId) {
        // no-op
    };
    AnalyticsProvider.prototype.chatDrawerClosed = function (dealId) {
        // no-op
    };
    AnalyticsProvider.prototype.chatMessageSent = function (dealId) {
        // no-op
    };
    AnalyticsProvider.prototype.pinFormViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.pinFormStarted = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.pinFormFinished = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.signInFormViewed = function () {
        // no-op
    };
    AnalyticsProvider.prototype.signInFormStarted = function () {
        // no-op
    };
    AnalyticsProvider.prototype.signInFormFinished = function () {
        // no-op
    };
    AnalyticsProvider.prototype.rebatesFormViewed = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.rebateAdded = function (dealId, vehicle) {
        // no-op
    };
    AnalyticsProvider.prototype.rebatesFormFinished = function (dealId, vehicle) {
        // no-op
    };
    return AnalyticsProvider;
}());
exports.AnalyticsProvider = AnalyticsProvider;
exports.default = AnalyticsProvider;
